<template>
    <table class="w-full">
        <tr v-if="membershipDiscount > 0">
            <td class="text-right px-4 py-4 align-top border-t border-gray-200 whitespace-no-wrap">
                <div class="flex items-start justify-between">
                    <span>
                        Membership Discount
                    </span>

                    <span>
                        - £{{ formattedMembershipDiscount }}
                    </span>
                </div>
            </td>
        </tr>
        <tr v-if="customerCredit > 0">
            <td class="text-right px-4 py-4 align-top border-t border-gray-200 whitespace-no-wrap">
                <div class="flex items-start justify-between">
                    <span>
                        Account Credit
                    </span>

                    <span>
                        - £{{ formattedCustomerCredit }}
                    </span>
                </div>
            </td>
        </tr>
        <tr>
            <td class="text-right px-4 py-4 align-top border-t border-gray-200">
                <div class="flex items-start justify-between">
                    <span class="font-semibold">
                        Total
                    </span>

                    <span>
                        £{{ formattedTotal }}
                    </span>
                </div>
            </td>
        </tr>
    </table>
</template>

<script>
	export default {
	    data() {
	        return {
                formattedTotal: '',
                membershipDiscount: 0,
                formattedMembershipDiscount: '',
                customerCredit: 0,
                formattedCustomerCredit: ''
            }
        },

		props: {
		    initialFormattedTotal: {
		        type: String,
                required: true,
            },

            initialMembershipDiscount: {
		        type: Number,
                required: true,
            },

            initialFormattedMembershipDiscount: {
		        type: String,
                required: true,
            },

            initialCustomerCredit: {
		        type: Number,
                required: true,
            },

            initialFormattedCustomerCredit: {
		        type: String,
                required: true,
            }
        },

        created() {
	        this.formattedTotal = this.initialFormattedTotal;
	        this.membershipDiscount = this.initialMembershipDiscount;
	        this.formattedMembershipDiscount = this.initialFormattedMembershipDiscount;
	        this.customerCredit = this.initialCustomerCredit;
	        this.formattedCustomerCredit = this.initialFormattedCustomerCredit;

	        bus.$on('update-checkout-basket-totals', () => {
	            axios.get('/checkout/basket-totals')
                    .then(response => {
                        this.formattedTotal = response.data.formatted_total;
                        this.membershipDiscount = response.data.membership_discount;
                        this.formattedMembershipDiscount = response.data.formatted_membership_discount;
                        this.customerCredit = response.data.customer_credit;
                        this.formattedCustomerCredit = response.data.formatted_customer_credit;
                    });
            });
        },
	}
</script>
